import React from 'react'
import './Services.css'

function Services() {
  return (
    <div className="services-section" id='Services'>
        <div className="container">
            <div className="services-content">
                <div className="services-header">
                    <div className="tagline">
                        <span>WHAT WE OFFER</span>
                    </div>
                    <h2>All You Need for Secure Cash Handling</h2>
                    <p className='text'>From cash movement to ATM services, air freight, and security solutions, we ensure safety and efficiency.</p>
                </div> 
                <div className="services-cards">

                    <div className="card">
                        <img src="./images/cashmovement.png" alt="" />
                        <h4>Cash Movement</h4>
                        <p className='text'>We manage all the logistics and risks involved in inter-state cash movement via the airways known as End-to-End Service. Let us take the burden off you while you take care.</p>
                    </div>

                    <div className="card">
                        <img src="./images/videobg.png" alt="" />
                        <h4>Security Services</h4>
                        <p className='text'>We are experts in the deployment of security services to nation’s financial institutions and corporate entities, a collaborative service with the Nigerian Police Force.</p>
                    </div>

                    <div className="card">
                        <img src="./images/air-freight.svg" alt="" />
                        <h4>Air Freight Movement</h4>
                        <p className='text'>We manage all the logistics and risks involved in inter-state cash movement via the airways known as End-to-End Service. Let us take the burden off you while you take care.</p>
                    </div>

                    <div className="card">
                        <img src="./images/atmservices.svg" alt="" />
                        <h4>Atm Services</h4>
                        <p className='text'>We are experts in the deployment of security services to nation’s financial institutions and corporate entities, a collaborative service with the Nigerian Police Force. </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Services